import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { surveyPanelService } from '../survey-panel-service/survey-panel.service';
import { PipeModel } from '../survey-models/pipe.model';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { NotifierService } from 'angular-notifier';
import { Observable, of } from 'rxjs';
import { RecruiterServices } from 'src/app/shared/services/recruiter.services';
import { Router } from '@angular/router';


export interface State {
  name: string;
  url: string;
  type: string;
}
export interface Food {
  value: string;
  viewValue: string;
}

export interface User {
  name: string;
}

@Component({
  selector: 'app-dialogbox',
  templateUrl: './dialogbox.component.html',
  styleUrls: ['./dialogbox.component.scss']
})
export class DialogboxComponent implements OnInit {

  foods: Food[] = [
    { value: 'steak-0', viewValue: 'Steak' },
    { value: 'pizza-1', viewValue: 'Pizza' },
    { value: 'tacos-2', viewValue: 'Tacos' }
  ];

  public stateCtrl = new FormControl();
  public filteredStates: Observable<State[]>;
  public surveyName: string;
  public surveystudyId: string;
  public surveyLanguageId: number;

  public optionList: any = [];
  public toppings = new FormControl();
  public pipelist: any = [1];
  public toppingList: any = [];
  public counter: number = 1;
  public pipeChoices: any;
  public fakeArray = [1];
  public pipeObject = new PipeModel;
  public isLooping: boolean = false;
  public isDelete: boolean = false;
  public dataIterat: number = 0;
  public questionKey: any;

  public flag = true;
  public addOnBlur = true;
  public removable = true;
  public selectable = true;
  public optionsCtrl = new FormControl();
  public options = [{ key: [] }];
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public isCreateSurvey: boolean = false;
  public localizationArray: any = [];
  public lanchecked: boolean = false;
  public surveyID: any;

  public fileSelectMsg: string = 'No file selected yet.';
  public fileUploadMsg: string = 'No file uploaded yet.';
  public disabled: boolean = false;
  public csvFile: any = '';
  public fileError: any = '';
  public fileErrorFlag: boolean = true;
  public finallocalizationArray: any = [];
  public matStatus: boolean = false;

  myControl = new FormControl();
  myoptions: User[] = [
    { name: 'Mary' },
    { name: 'Shelley' },
    { name: 'Igor' }
  ];
  filteredOptions: Observable<User[]>;



  @ViewChild('optionsInput', {static: false}) optionsInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', {static: false}) matAutocomplete: MatAutocomplete;
  @ViewChild('local', {static: false}) local: ElementRef<HTMLInputElement>;
  @ViewChild('optionId', {static: false}) studyId: any;
  @ViewChild('temp2', {static: false}) temp2: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<DialogboxComponent>,
    public surveyservice: surveyPanelService,
    public router: Router,
    private notifier: NotifierService,
    private recruiterServices: RecruiterServices,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }


  public _filter(name: string): User[] {
    const filterValue = name.toLowerCase();
    return this.localizationArray.filter(option => option.text.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit() {
    this.stateCtrl.valueChanges.subscribe(keyword => {
      this.surveystudyId = undefined;
      if (keyword.length < 2) {
      }
      if (keyword.length > 2) {
        this.recruiterServices.getAllRecruiterBykeyword(keyword, 'study').subscribe(data => {
          if (data.result)
            this.filteredStates = of(data.result);
        });
      }
    });

    if (this.data != undefined && this.data.page == "createsurvey") {
      this.isCreateSurvey = true;
      this.fetchLocalization();
      this.myControl.valueChanges.subscribe(keyword => {
        this.onKeyPress_create(keyword);
      });
    } else if (this.data != undefined && this.data.page == "pipepopup") {
      this.isCreateSurvey = false;
      this.isLooping = this.data.multiChoiceQuestion.entity.misc.quesPipingType ? this.data.multiChoiceQuestion.entity.misc.quesPipingType.isLooping : false;
      this.optionList = this.surveyservice.pipeoptions;
      if (this.data.pipeIndex != -1) {
        this.pipeEdit();
      } else {
        this.pipeObject.data.push({ tagType: 'T', operator: '5', operand: { L: { type: "Q", id: [] }, R: { type: "C", id: [] } } });
        this.pipeObject.data[0].operand.L.id[0] = JSON.stringify(this.optionList[this.keys()[0]].entity.entityId);
        this.optionList[this.keys()[0]].choices.options.forEach(element => {
          this.options[this.dataIterat].key.push({ name: element.text, id: element.id });
        });
        this.pipeObject.data[0].operand.L.id[0] = JSON.stringify(this.optionList[this.keys()[0]].entity.entityId);
      }
      if (this.pipeObject.data.length > 1) {
        this.isDelete = true;
      }
    } else if (this.data != undefined && this.data.page == 'languagePopUp') {
      this.fetchLocalization();
    }
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }
  public hideAllNotifications(): void {
    this.notifier.hideAll();
  }

  checkOpt() {
    this.pipeObject.data[0].operand.R.id = this.pipeChoices;
  }

  addmorepipe() {
    this.options.push({ key: [] });
    this.pipeObject.data[this.dataIterat].merger = '3';
    this.dataIterat++;
    this.optionList[this.keys()[0]].choices.options.forEach(element => {
      this.options[this.dataIterat].key.push({ name: element.text, id: element.id });
    });
    this.pipeObject.data.push({ tagType: 'T', operator: '5', operand: { L: { type: "Q", id: [] }, R: { type: "C", id: [] } } });
    this.pipeObject.data[this.dataIterat].operand.L.id[0] = JSON.stringify(this.optionList[this.keys()[0]].entity.entityId);
    this.isDelete = true;
  }

  removemorepipe(index) {
    this.dataIterat--;
    if (this.pipeObject.data.length > 1) {
      this.pipeObject.data.splice(index, 1);
      this.options.splice(index, 1);
    }
    if (this.pipeObject.data.length === 1) {
      this.isDelete = false;
    }
  }

  pipeOptionChange(pipe: any, event: any, opt: any, optionIndex) {
    this.options[optionIndex].key = [];
    opt.forEach((element: any) => {
      this.options[optionIndex].key.push({ name: element.text, id: element.id });
    });
  }

  savemorepipe() {
    let flag = false;
    for (let i = 0; i <= this.dataIterat; i++) {
      this.pipeObject.data[i].operand.R.id = [];
      this.options[i].key.forEach((option) => {
        this.pipeObject.data[i].operand.R.id.push(option.id);
      });
      if (this.pipeObject.data[i].operand.R.id.length == 0) {
        flag = true;
      }
    }
    if (!flag) {
      let tempMultiQues = JSON.parse(JSON.stringify(this.data.multiChoiceQuestion));
      if (this.data.pipeType == 'question') {
        this.questionPipe(this.pipeObject, this.data.pipeIndex);
      }
      if (this.data.pipeType == 'option') {
        this.optionPipe(this.pipeObject);
      }
      if (!this.checkPipingRedendenc()) {
        this.dialogRef.close(this.data.multiChoiceQuestion);
      } else {
        this.data.multiChoiceQuestion = JSON.parse(JSON.stringify(tempMultiQues));
        this.showNotification('error', 'Cannot pipe with same question');
      }
    } else {
      this.showNotification('error', 'Please enter toppings');
    }
  }

  checkPipingRedendenc(): boolean {
    let isRed: boolean = false;

    if (this.data.pipeType == 'question') {
      this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition.forEach((condition) => {
        let conditionIndex = this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition.indexOf(condition);
        condition.data.forEach((data) => {
          let id = data.operand.L.id[0];
          let idIndex = condition.data.indexOf(data);
          this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition.forEach((conditionInner) => {
            let conditionInnerIndex = this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition.indexOf(conditionInner);
            conditionInner.data.forEach((data1) => {
              if (id == data1.operand.L.id[0] && conditionInnerIndex != conditionIndex) {
                isRed = true;
                return isRed;
              } else {
                if (id == data1.operand.L.id[0] && idIndex != conditionInner.data.indexOf(data1)) {
                  isRed = true;
                  return isRed;
                }
              }
            });
          });
        });
      });
    }
    if (this.data.pipeType == 'option') {
      this.data.multiChoiceQuestion.entity.misc.choicePipingType.condition.forEach((condition) => {
        let conditionIndex = this.data.multiChoiceQuestion.entity.misc.choicePipingType.condition.indexOf(condition);
        condition.data.forEach((data) => {
          let id = data.operand.L.id[0];
          let idIndex = condition.data.indexOf(data);
          this.data.multiChoiceQuestion.entity.misc.choicePipingType.condition.forEach((conditionInner) => {
            let conditionInnerIndex = this.data.multiChoiceQuestion.entity.misc.choicePipingType.condition.indexOf(conditionInner);
            conditionInner.data.forEach((data1) => {
              if (id == data1.operand.L.id[0] && conditionInnerIndex != conditionIndex) {
                isRed = true;
                return isRed;
              } else {
                if (id == data1.operand.L.id[0] && idIndex != conditionInner.data.indexOf(data1)) {
                  isRed = true;
                  return isRed;
                }
              }
            });
          });
        });
      });
    }
    return isRed;
  }

  questionPipe(result: any, index: number) {

    if (index != -1) {
      result.name = this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition[index].name;
      result.data.forEach((data) => {
        if (!Array.isArray(data.operand.L.id)) {
          let temp = JSON.stringify(data.operand.L.id);
          data.operand.L.id = [];
          data.operand.L.id.push(temp);
        }
      });
      this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition[index] = result;
    } else {
      let pipeName = ' {{pipe' + (Object.keys(this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition).length + 1) + '}}';
      result.name = 'pipe' + (Object.keys(this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition).length + 1);
      result.data.forEach((data) => {
        if (!Array.isArray(data.operand.L.id)) {
          let temp = JSON.stringify(data.operand.L.id);
          data.operand.L.id = [];
          data.operand.L.id.push(temp);
        }
      });
      this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition.push(result);
      this.data.multiChoiceQuestion.entity.text = this.data.multiChoiceQuestion.entity.text + pipeName;
    }
    Object.assign(this.data.multiChoiceQuestion.entity.misc.quesPipingType, { isLooping: this.isLooping });
    this.data.multiChoiceQuestion.entity.misc.quesPipingType.type = this.isLooping ? 'looping' : 'multipiping';
  }

  optionPipe(result: any) {
    let codeCount = this.maxCode();
    result.data.forEach((data) => {
      if (!Array.isArray(data.operand.L.id)) {
        let temp = JSON.stringify(data.operand.L.id);
        data.operand.L.id = [];
        data.operand.L.id.push(temp);
      }
    });
    this.data.multiChoiceQuestion.entity.misc.choicePipingType.condition.push(result);
    result.data.forEach((option) => {
      let i = 0;
      const questionNo = 'Q' + this.surveyservice.pipeoptions['q' + option.operand.L.id[0]].entity.entitySeq;
      const quesId: string = option.operand.L.id[0];
      for (let j = 0; j < Object.keys(option).length - 1; j++) {
        this.surveyservice.pipeoptions['q' + option.operand.L.id[0]].choices.options.forEach((opt) => {
          if (opt.id == option.operand.R.id[i]) {
            let tempOpt = JSON.parse(JSON.stringify(opt));
            tempOpt.misc = [{ min: "1", max: "", interval: "1", ques: [quesId.toString()], operator: option.operator, quesNo: questionNo, tagType: option.tagType, pipeId: option.operand.R.id[i] }];
            tempOpt.code = codeCount;
            tempOpt.id = '';
            this.data.multiChoiceQuestion.choices.options.push(tempOpt);
            codeCount++;
            i++;
          }
        });
      }
    });
  }

  maxCode(): number {
    let codeCount = 0;
    this.data.multiChoiceQuestion.choices.options.forEach((opt) => {
      if (opt.code > codeCount) {
        codeCount = opt.code;
      }
    });
    codeCount++;
    return codeCount;
  }

  toggleLoop() {
    this.isLooping = !this.isLooping;
  }

  keys(): Array<string> {
    let i = 1;
    let keyOption: any = [];

    Object.keys(this.surveyservice.pipeoptions).forEach((elem) => {
      if (i < this.data.questionIndex) {
        keyOption.push(elem);
        i++;
      } else if (i == this.data.questionIndex) {
        this.questionKey = elem;
        i++;
      }
    });
    return keyOption;
  }
  checkLength(option: string): string {
    return option.length >= 20 ? option.substring(0, 20) + '...' : option;
  }


  // auto compleate session start

  selected(event: MatAutocompleteSelectedEvent, optionIndex: number): void {
    this.options[optionIndex].key.push({ name: event.option.viewValue, id: event.option.value });
    this.optionsInput.nativeElement.value = '';
    this.optionsCtrl.setValue(null);
    this.flag = true;
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
    }
    else {
      if (this.flag) {
        let local = this.local;
        let temp2 = this.temp2;
        setTimeout(function () {
          local.nativeElement.focus();
          setTimeout(function () {
          })
        }, 150);
      }
    }
  }

  remove(opt: string, optionIndex: number): void {
    const index = this.options[optionIndex].key.indexOf(opt);
    if (index >= 0) {
      this.options[optionIndex].key.splice(index, 1);
    }
    this.flag = true;
  }
  // auto compleate session end


  pipeEdit() {
    let temData = JSON.parse(JSON.stringify(this.data.multiChoiceQuestion));
    this.keys();
    temData.entity.misc.quesPipingType.condition[this.data.pipeIndex].data.forEach((data) => {
      this.options.push({ key: [] });
      this.optionList['q' + (data.operand.L.id[0])].choices.options.forEach(element => {
        if (data.operand.R.id.indexOf(element.id) > -1) {
          this.options[this.dataIterat].key.push({ name: element.text, id: element.id });
        }
      });
      this.dataIterat++;
    });
    this.pipeObject.data = temData.entity.misc.quesPipingType.condition[this.data.pipeIndex].data;
    this.dataIterat--;
  }

  closeDialog() {
    this.dialogRef.close('close');
  }

  checkQuestionLength(): boolean {
    let questionPIpeLength = this.data.multiChoiceQuestion.entity.misc.quesPipingType.condition.length;
    return questionPIpeLength >= 1 ? this.data.pipeIndex == 0 && questionPIpeLength == 1 ? false : true : false;
  }

  getConvertedId(value: any): any {
    return JSON.stringify(value);
  }

  checkQuestionType(type: string): boolean {
    if (type === '5' || type === '4') {
      return false;
    }
    return true;
  }

  openCreator(): void {
    if (this.surveyName == undefined || this.surveyName == "") {
      this.showNotification('error', 'Please enter Survey name');
    } else if (this.surveystudyId == undefined) {
      this.showNotification('error', 'Please enter valid Study name');
    } else if (this.surveyLanguageId == undefined) {
      this.showNotification('error', 'Please select survey language');
    } else {
      var sdata = { "survey_name": this.surveyName, "studies_id": this.surveystudyId, "survey_lan": this.surveyLanguageId };
      this.surveyservice.createSurvey(sdata).subscribe((data) => {
        if (data) {
          this.surveyName = this.surveyName;
          this.router.navigate(['/survey-panel/', data['survey_id']]);
          this.dialogRef.close('close');
        }
      });
    }
  }

  gotoSearchpage(id) {
    this.surveystudyId = id;
  }

  changeToElip(str: string): string {
    if (str.length > 18) {
      str = str.slice(0, 18) + '...';
    }
    return str;
  }

  fetchLocalization() {
    this.surveyservice.getLocalization().subscribe(res => {
      res['response']['result'].forEach((element, index) => {
        var n;
        if (this.data.xoptions != undefined) {
          var fruits = this.data.xoptions;
          n = fruits.includes(element.key);
        }
        if (this.data.default != undefined && (this.data.default.code == element.key)) {
          n = true;
        }
        var misc = { "interval": 1, "languageId": element.id, "max": "", "min": 1 };
        var option = { "code": element.key, "label": element.name, "text": element.name, "misc": misc, "checked": n };
        this.localizationArray.push(option);
      });
    });
    this.finallocalizationArray = this.localizationArray;
  }

  checkedall(cond) {
    this.lanchecked = cond;
    this.localizationArray.forEach((element, index) => {
      this.localizationArray[index]['checked'] = cond;
    });



  }
  createLanguage() {
    this.matStatus = false;
    var options = [];
    this.localizationArray.forEach(element => {

      if (element.checked == true) {
        options.push(element);
      }
    });

    this.data.gqdata[0].entity.surveyId = this.data.surveyid;
    this.data.gqdata[0].choices.options = options;

    if (this.data.gqdata[0].choices.options.length >= 1) {
      if (this.data.operation == "add") {
        if (this.data.gqdata[0].GenericId == 39) {
          this.data.gqdata[0].entity.sequence.replaceId = this.data.firstQues;
          this.data.gqdata[0].entity.sequence.selected = this.data.firstQues ? (this.data.firstQues + "_" + "-1") : this.data.firstQues;
        }
        // this.surveyservice.addQuestion({ "process": this.data.gqdata, "surveyId": this.data.surveyid, "api_survey_id": this.data.api_survey_id }).subscribe(
        //   (data) => {
        //     if (data) {
        //       this.matStatus = true;
        //       this.showNotification('success', "Language created successfully !!");
        //       //    this.dialogRef.close("success");
        //     }
        //   },
        //   (error) => {
        //     console.error(error);
        //     this.showNotification('error', "Server error !!");
        //   });
      } else {
        // this.surveyservice.updateQuestion({ "process": this.data.gqdata, "surveyId": this.data.surveyid, "api_survey_id": this.data.api_survey_id }).subscribe(
        //   (data) => {
        //     if (data) {
        //       this.matStatus = true;
        //       this.showNotification('success', "Language updated successfully !!");
        //     }
        //   },
        //   (error) => {
        //     console.error(error);
        //     this.showNotification('error', "Server error !!");
        //   });
      }
    } else {
      this.showNotification('error', "Please select atleast one language!");
    }
  }

  cancelLanguage() {
    this.dialogRef.close("cancel");
  }

  downloadCSV() {
    let filename = "Survey_Language_" + this.data.api_survey_id + '.csv';
    this.surveyservice.getLocalizationCsv(this.data.api_survey_id).subscribe(res => {
      this.DownloadJSON2CSV(filename, JSON.parse(res['response']).result);
    });
  }

  DownloadJSON2CSV(filename, rows) {

    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvData =
      keys.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  onFileChanged(event) {
    this.csvFile = event.target.files[0];
    if (this.csvFile.type == 'text/csv' || this.csvFile.type == "application/vnd.ms-excel") {
      this.fileErrorFlag = true;
      this.fileSelectMsg = this.csvFile.name;
    }
    else {
      this.fileError = `This file format can't be uploaded. Please use csv file format`;
      this.fileSelectMsg = this.csvFile.name;
      this.fileErrorFlag = false;
    }
  }

  UploadLanguageCsv() {
    if (this.csvFile == "") {
      this.notifier.notify("error", "Click on browse and locate your translation file");
    } else {
      this.surveyservice.languageCsvUplaod(this.csvFile, this.data.api_survey_id).subscribe(res => {
        this.notifier.notify("success", "Language updated !!");
      });
    }
  }

  onKeyPress(event) {
    let newArray = [];
    let val = event.target.value;
    let i = 0;
    this.localizationArray.filter(res => {
      if (res.text.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
        newArray[i] = res;
        i++;
      }
    });
    this.localizationArray = newArray;
    if (val == "") {
      this.localizationArray = this.finallocalizationArray;
    }
  }


  onKeyPress_create(val) {
    let newArray = [];
    let i = 0;
    this.localizationArray.filter(res => {
      if (res.text.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
        newArray[i] = res;
        i++;
      }
    });
    this.localizationArray = newArray;
    if (val == "") {
      this.localizationArray = this.finallocalizationArray;
    }
  }

  assignLanguageID(lanid) {
    this.surveyLanguageId = lanid;
  }

  confirmBlock() {
    this.dialogRef.close('confirm');
  }

}




